export const martaAndracka = {
    'meta': {
        'title': 'Psychiatra Marta Andracka • Centrum COLLIGO',
        'description': 'Lekarz psychiatra. Doświadczenie zdobyłam na oddziałach psychiatrycznych, poradni uzależnień, poradniach zdrowia psychicznego i poradni psychogeriatrycznej.'
    },
    'url': {
        'address': '/torun/zespol/psychiatra-marta-andracka/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/marta-andracka.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psychiatra Marta Andracka'
        }
    }
}